import React from "react";
import SocketClient from "../socketClient/socketClient";

export const SocketContext = React.createContext<SocketClient>(null);
